export default __webpack_public_path__ + "static/media/227.8cbb94bb.png";